module.exports = __webpack_public_path__ + "img/logo.4d3a0bbc.svg";